import script from "./ModuleCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleCarousel.vue?vue&type=style&index=0&id=280ca192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280ca192"]])

export default __exports__